export default __webpack_public_path__ + "static/media/LoyaltyInactive.d7264ea6.svg";